"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var Hint_exports = {};
__export(Hint_exports, {
  default: () => Hint_default
});
module.exports = __toCommonJS(Hint_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 21 20",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M10.5 1.91016C11.4245 1.91016 12.2904 2.07292 13.0977 2.39844C13.9049 2.72396 14.6081 3.17969 15.207 3.76562C15.819 4.35156 16.3008 5.05469 16.6523 5.875C16.9909 6.68229 17.1602 7.57422 17.1602 8.55078C17.1602 9.55339 17.0039 10.3542 16.6914 10.9531C16.3919 11.5521 16.0208 12.0729 15.5781 12.5156L15.3438 12.7695L14.5625 13.5117C14.4323 13.6419 14.3021 13.7721 14.1719 13.9023C14.0547 14.0326 13.944 14.1693 13.8398 14.3125C13.7227 14.4557 13.612 14.612 13.5078 14.7812C13.4167 14.9375 13.332 15.1068 13.2539 15.2891C13.4232 15.3411 13.5599 15.4388 13.6641 15.582C13.7812 15.7253 13.8398 15.8945 13.8398 16.0898C13.8398 16.3112 13.7552 16.5065 13.5859 16.6758C13.4297 16.832 13.2344 16.9102 13 16.9102H12.9219C12.9479 16.9753 12.9674 17.0469 12.9805 17.125C12.9935 17.1901 13 17.2617 13 17.3398C13 17.6784 12.8763 17.9714 12.6289 18.2188C12.3945 18.4661 12.1016 18.5898 11.75 18.5898H9.25C8.89844 18.5898 8.59896 18.4661 8.35156 18.2188C8.11719 17.9714 8 17.6784 8 17.3398C8 17.2617 8.00651 17.1901 8.01953 17.125C8.03255 17.0469 8.05208 16.9753 8.07812 16.9102H8C7.76562 16.9102 7.5638 16.832 7.39453 16.6758C7.23828 16.5065 7.16016 16.3112 7.16016 16.0898C7.16016 15.8945 7.21224 15.7253 7.31641 15.582C7.43359 15.4388 7.57682 15.3411 7.74609 15.2891C7.66797 15.1068 7.57682 14.9375 7.47266 14.7812C7.38151 14.612 7.27734 14.4557 7.16016 14.3125C7.06901 14.1953 6.97135 14.0846 6.86719 13.9805C6.76302 13.8633 6.65885 13.7526 6.55469 13.6484L6.18359 13.2773L5.65625 12.7695L5.42188 12.5156C4.97917 12.0729 4.60156 11.5521 4.28906 10.9531C3.98958 10.3542 3.83984 9.55339 3.83984 8.55078C3.83984 7.57422 4.00911 6.68229 4.34766 5.875C4.69922 5.05469 5.17448 4.35156 5.77344 3.76562C6.38542 3.17969 7.09505 2.72396 7.90234 2.39844C8.70964 2.07292 9.57552 1.91016 10.5 1.91016ZM10.5 2.75C9.66667 2.75 8.89844 2.89323 8.19531 3.17969C7.47917 3.47917 6.86068 3.88932 6.33984 4.41016C5.81901 4.91797 5.40885 5.52344 5.10938 6.22656C4.8099 6.94271 4.66016 7.71745 4.66016 8.55078C4.66016 9.41016 4.78385 10.1003 5.03125 10.6211C5.29167 11.1289 5.76042 11.7148 6.4375 12.3789L6.98438 12.8867L7.23828 13.1406C7.2513 13.1536 7.26432 13.1732 7.27734 13.1992C7.30339 13.2122 7.32292 13.2318 7.33594 13.2578L7.53125 13.4727C7.55729 13.4857 7.57682 13.5052 7.58984 13.5312C7.60286 13.5443 7.61589 13.5573 7.62891 13.5703L7.82422 13.7852C7.98047 13.9805 8.11719 14.1888 8.23438 14.4102C8.36458 14.6315 8.47526 14.8659 8.56641 15.1133L8.625 15.25H12.375L12.4336 15.1133C12.5117 14.9049 12.5964 14.7096 12.6875 14.5273C12.7917 14.3451 12.9089 14.1628 13.0391 13.9805L13.1758 13.7852L13.2734 13.6875L13.4688 13.4727L13.6641 13.2578L13.8984 13.0234L14.1719 12.75L14.3867 12.5352C15.1289 11.819 15.6367 11.2005 15.9102 10.6797C16.1966 10.1589 16.3398 9.44922 16.3398 8.55078C16.3398 7.71745 16.1901 6.94271 15.8906 6.22656C15.5911 5.52344 15.181 4.91797 14.6602 4.41016C14.1393 3.88932 13.5208 3.47917 12.8047 3.17969C12.1016 2.89323 11.3333 2.75 10.5 2.75ZM11.8672 5.44531C12.0365 5.58854 12.1341 5.76432 12.1602 5.97266C12.1862 6.18099 12.1406 6.36979 12.0234 6.53906L11.9648 6.61719L10.6367 8.16016H12.1602C12.4987 8.16016 12.7461 8.3099 12.9023 8.60938C13.0586 8.90885 13.0456 9.19531 12.8633 9.46875L12.8047 9.54688L10.3047 12.457C10.1484 12.6393 9.95312 12.737 9.71875 12.75C9.4974 12.763 9.30208 12.6979 9.13281 12.5547C8.96354 12.4115 8.86589 12.2357 8.83984 12.0273C8.8138 11.819 8.85938 11.6302 8.97656 11.4609L9.03516 11.3828L10.3633 9.83984H8.83984C8.5013 9.83984 8.25391 9.6901 8.09766 9.39062C7.94141 9.09115 7.95443 8.80469 8.13672 8.53125L8.19531 8.45312L10.6953 5.54297C10.8516 5.36068 11.0404 5.26302 11.2617 5.25C11.4961 5.23698 11.6979 5.30208 11.8672 5.44531Z",
      fill: "currentColor"
    }
  )
);
const SvgHint = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var Hint_default = SvgHint;
